import React, { useContext, useState, Component } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import { AccountContext } from "../../provider";
import LoginPage from "./login";
import SignupPage from "./signup";
import OTPPage from "./otp";

import { Row } from "../../comps";
import { serverArt } from "../../theme/image";

const VIEW_TYPE = {
  LOGIN: 0,
  SIGNUP: 1,
  OTP: 2,
  PROFILE: 3,
};

const Wrapper = styled(Row)`
  width: 100%;
  height: 100vh;
  margin: 0px;
  padding: 80px;
  background: ${({ theme }) => theme.color.BLACK_3};
  justify-content: space-between;
  align-items: center;
`;

const ArtWrapper = styled(Row)`
  width: 45%;
  height: 100%;
  align-items: center;
`;

const Art = styled.img`
  width: 90%;
  height: auto;
`;

export default () => {
  const [userInfo, setuserInfo] = useContext(AccountContext);
  const { isLoggedIn } = userInfo;
  const [state, setState] = useState({ view: 0 });
  const { email, view } = state;

  const changeState = (view, email) => {
    const newState = { view, email };
    setState(newState);
  };

  const getForm = () => {
    switch (view) {
      case VIEW_TYPE.LOGIN:
        return <LoginPage changeState={changeState} VIEW_TYPE={VIEW_TYPE} />;
      case VIEW_TYPE.SIGNUP:
        return <SignupPage changeState={changeState} VIEW_TYPE={VIEW_TYPE} />;
      case VIEW_TYPE.OTP:
        return (
          <OTPPage
            email={email}
            changeState={changeState}
            VIEW_TYPE={VIEW_TYPE}
          />
        );
      case VIEW_TYPE.PROFILE:
        return <Redirect push to={`/profile`} />;
      case VIEW_TYPE.HOME:
        return <Redirect push to={`/`} />;
    }
  };

  if (isLoggedIn) return <Redirect push to={`/profile`} />;

  return (
    <Wrapper>
      <ArtWrapper>
        <Art src={serverArt} />
      </ArtWrapper>
      {getForm()}
    </Wrapper>
  );
};
